import { Card, CardBody, Col } from "reactstrap";
import Swal from "sweetalert2";
import { Btn } from "../../../AbstractElements";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { BasicAlertTitle, ClickIt } from "../../../Constants/Constants";
import { BasicAlertSubTitle } from "../../../Data/BonusUi/SweetAlert";

const BasicAlert = () => {
  const handleAlert = () => Swal.fire("Welcome! to the Berlin theme");
  return (
    <Col xxl="3" xl="4" sm="6" xs="12" className="box-col-4">
      <Card className="height-equal">
        <CommonCardHeader title={BasicAlertTitle} span={BasicAlertSubTitle} />
        <CardBody className="btn-showcase">
          <Btn color="primary" className="m-0" onClick={handleAlert}>
            {ClickIt}
          </Btn>
        </CardBody>
      </Card>
    </Col>
  );
};
export default BasicAlert;
